 
    let animationFrame = null;
    let currentFontFace = null;
    let isExporting = false;
    let rawFontArrayBuffer = null;
    let detectedAxesMap = {};

    const fontFileInput = document.getElementById('font-file');
    const uploadLabel = document.getElementById('upload-label');
    const aspectRatioSelect = document.getElementById('aspect-ratio');
    const previewCard = document.getElementById('preview-card');
    const kerningToggle = document.getElementById('kerning-toggle');
    const axisRangeList = document.getElementById('axisRangeList');
    
    const bgColorPicker = document.getElementById('bg-color-picker');
    const bgHexInput = document.getElementById('bg-hex-input');
    const textColorPicker = document.getElementById('text-color-picker');
    const textHexInput = document.getElementById('text-hex-input');

    const axisTagInput = document.getElementById('axis-tag');
    const axisMinInput = document.getElementById('axis-min');
    const axisMaxInput = document.getElementById('axis-max');
    const sampleTextInput = document.getElementById('sample-text');
    const fontSizeInput = document.getElementById('font-size');
    const exportWebmBtn = document.getElementById('export-webm-btn');
    const exportWebpBtn = document.getElementById('export-webp-btn');
    const status = document.getElementById('status');
    const canvas = document.getElementById('preview-canvas');
    const ctx = canvas.getContext('2d');

    // Sync Background Color Picker & Hex Text Box
    bgColorPicker.addEventListener('input', () => {
      bgHexInput.value = bgColorPicker.value.toUpperCase();
      if (!isExporting && currentFontFace) drawCanvasText(parseFloat(axisMinInput.value));
    });
    bgHexInput.addEventListener('input', () => {
      let val = bgHexInput.value;
      if (!val.startsWith('#')) val = '#' + val;
      if (/^#[0-9A-Fa-f]{6}$/.test(val)) {
        bgColorPicker.value = val;
        if (!isExporting && currentFontFace) drawCanvasText(parseFloat(axisMinInput.value));
      }
    });

    // Sync Text Color Picker & Hex Text Box
    textColorPicker.addEventListener('input', () => {
      textHexInput.value = textColorPicker.value.toUpperCase();
      if (!isExporting && currentFontFace) drawCanvasText(parseFloat(axisMinInput.value));
    });
    textHexInput.addEventListener('input', () => {
      let val = textHexInput.value;
      if (!val.startsWith('#')) val = '#' + val;
      if (/^#[0-9A-Fa-f]{6}$/.test(val)) {
        textColorPicker.value = val;
        if (!isExporting && currentFontFace) drawCanvasText(parseFloat(axisMinInput.value));
      }
    });

    // Handle Kerning Toggle
    kerningToggle.addEventListener('change', () => {
      const useKern = kerningToggle.checked;
      ctx.fontKerning = useKern ? 'normal' : 'none';
      previewCard.style.fontKerning = useKern ? 'normal' : 'none';
      previewCard.style.fontFeatureSettings = useKern ? '"kern" 1' : '"kern" 0';
      if (!isExporting && currentFontFace) drawCanvasText(parseFloat(axisMinInput.value));
    });

    // Handle Aspect Ratio Changes & Auto-Scale Font Size Proportionally
    aspectRatioSelect.addEventListener('change', () => {
      const oldHeight = canvas.height;
      const val = aspectRatioSelect.value;
      
      if (val === '3:2') {
        canvas.width = 1200;
        canvas.height = 800;
        previewCard.style.width = '512px';
        previewCard.style.height = '341.5px';
      } else if (val === '16:9') {
        canvas.width = 1200;
        canvas.height = 675;
        previewCard.style.width = '600px';
        previewCard.style.height = '337.5px';
      } else if (val === '1:1') {
        canvas.width = 1080;
        canvas.height = 1080;
        previewCard.style.width = '400px';
        previewCard.style.height = '400px';
      } else if (val === '9:16') {
        canvas.width = 1080;
        canvas.height = 1920;
        previewCard.style.width = '270px';
        previewCard.style.height = '480px';
      }

      const scaleRatio = canvas.height / oldHeight;
      fontSizeInput.value = Math.round(parseFloat(fontSizeInput.value) * scaleRatio);

      if (currentFontFace) startLivePreview();
    });

    // Handle Axis Tag Change to Update Bounds Automatically
    axisTagInput.addEventListener('change', () => {
      const selectedTag = axisTagInput.value;
      if (detectedAxesMap[selectedTag]) {
        axisMinInput.value = detectedAxesMap[selectedTag].min;
        axisMaxInput.value = detectedAxesMap[selectedTag].max;
        if (!isExporting && currentFontFace) startLivePreview();
      }
    });

    // Parse fvar table to extract variable axes and ranges
    function parseVariableAxes(arrayBuffer) {
      try {
        const dataView = new DataView(arrayBuffer);
        let numTables = dataView.getUint16(4);
        let tableDirectoryOffset = 12;
        let fvarOffset = null;

        for (let i = 0; i < numTables; i++) {
          const tag = String.fromCharCode(
            dataView.getUint8(tableDirectoryOffset + 0),
            dataView.getUint8(tableDirectoryOffset + 1),
            dataView.getUint8(tableDirectoryOffset + 2),
            dataView.getUint8(tableDirectoryOffset + 3)
          );
          if (tag === 'fvar') {
            fvarOffset = dataView.getUint32(tableDirectoryOffset + 8);
            break;
          }
          tableDirectoryOffset += 16;
        }

        axisRangeList.innerHTML = '';
        detectedAxesMap = {};

        if (fvarOffset === null) {
          axisRangeList.innerHTML = '<li><em>Static font (no fvar table found)</em></li>';
          return;
        }

        const axesArrayOffset = dataView.getUint16(fvarOffset + 4);
        const axisCount = dataView.getUint16(fvarOffset + 8);
        const axisSize = dataView.getUint16(fvarOffset + 10);
        
        let currentOffset = fvarOffset + axesArrayOffset;
        let axesFound = [];

        for (let i = 0; i < axisCount; i++) {
          const axisTag = String.fromCharCode(
            dataView.getUint8(currentOffset + 0),
            dataView.getUint8(currentOffset + 1),
            dataView.getUint8(currentOffset + 2),
            dataView.getUint8(currentOffset + 3)
          );
          const minValue = dataView.getInt32(currentOffset + 4) / 65536.0;
          const defaultValue = dataView.getInt32(currentOffset + 8) / 65536.0;
          const maxValue = dataView.getInt32(currentOffset + 12) / 65536.0;

          detectedAxesMap[axisTag] = { min: minValue, max: maxValue, default: defaultValue };
          axesFound.push(`<strong>${axisTag}</strong>: ${minValue} to ${maxValue} (default ${defaultValue})`);
          currentOffset += axisSize;
        }

        if (axesFound.length > 0) {
          axesFound.forEach(info => {
            const li = document.createElement('li');
            li.innerHTML = info;
            axisRangeList.appendChild(li);
          });

          // Sync range inputs to currently selected axis tag if available, or default to first discovered axis
          const currentTag = axisTagInput.value;
          if (detectedAxesMap[currentTag]) {
            axisMinInput.value = detectedAxesMap[currentTag].min;
            axisMaxInput.value = detectedAxesMap[currentTag].max;
          } else {
            const firstTag = Object.keys(detectedAxesMap)[0];
            if (firstTag) {
              axisTagInput.value = firstTag;
              axisMinInput.value = detectedAxesMap[firstTag].min;
              axisMaxInput.value = detectedAxesMap[firstTag].max;
            }
          }
        } else {
          axisRangeList.innerHTML = '<li><em>No axes detected</em></li>';
        }
      } catch (e) {
        console.error("Axis parsing warning:", e);
        axisRangeList.innerHTML = '<li><em>Could not parse axis table</em></li>';
      }
    }

    // Core font loader function shared by file input and drag-and-drop
    async function loadFontFile(file) {
      if (!file) return;

      uploadLabel.textContent = file.name;
      status.textContent = "Loading font into browser engine...";

      try {
        rawFontArrayBuffer = await file.arrayBuffer();
        
        // Parse fvar for ranges list
        parseVariableAxes(rawFontArrayBuffer);

        const fontBlob = new Blob([rawFontArrayBuffer]);
        const fontUrl = URL.createObjectURL(fontBlob);
        
        const fontFamily = "WebFontDynamic";
        if (currentFontFace) document.fonts.delete(currentFontFace);

        currentFontFace = new FontFace(fontFamily, `url(${fontUrl})`);
        await currentFontFace.load();
        document.fonts.add(currentFontFace);

        exportWebmBtn.disabled = false;
        exportWebpBtn.disabled = false;
        status.textContent = "Font loaded successfully. Previewing animation.";
        startLivePreview();

      } catch (err) {
        console.error("Font loading error:", err);
        status.textContent = "Error loading font file. Ensure it is a valid font.";
      }
    }

    // 1. File Input Trigger
    fontFileInput.addEventListener('change', (e) => {
      loadFontFile(e.target.files[0]);
    });

    // 1b. Drag and Drop Handlers
    window.addEventListener('dragover', (e) => {
      e.preventDefault();
      e.stopPropagation();
      document.body.classList.add('is-dragging');
    });

    window.addEventListener('dragleave', (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (e.clientX === 0 && e.clientY === 0) {
        document.body.classList.remove('is-dragging');
      }
    });

    window.addEventListener('drop', (e) => {
      e.preventDefault();
      e.stopPropagation();
      document.body.classList.remove('is-dragging');

      const files = e.dataTransfer.files;
      if (files && files.length > 0) {
        loadFontFile(files[0]);
      }
    });

    // 2. High-DPI Canvas Renderer
    function drawCanvasText(value) {
      const tag = axisTagInput.value;
      const fontSize = parseFloat(fontSizeInput.value);
      const text = sampleTextInput.value;

      ctx.fillStyle = bgColorPicker.value;
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      ctx.fillStyle = textColorPicker.value;
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      
      ctx.fontKerning = kerningToggle.checked ? 'normal' : 'none';

      canvas.style.fontVariationSettings = `"${tag}" ${value}`;
      ctx.font = `${fontSize}px "WebFontDynamic", sans-serif`;

      const lines = text.split('\n');
      const lineHeight = fontSize * 1.15;
      const startY = (canvas.height / 2) - ((lines.length - 1) * lineHeight / 2);

      lines.forEach((line, index) => {
        ctx.fillText(line, canvas.width / 2, startY + (index * lineHeight));
      });
    }

    // 3. Smooth Preview Engine
    function startLivePreview() {
      if (animationFrame) cancelAnimationFrame(animationFrame);

      const min = parseFloat(axisMinInput.value);
      const max = parseFloat(axisMaxInput.value);
      const duration = parseFloat(document.getElementById('anim-duration').value) * 1000;

      let startTime = null;

      function step(timestamp) {
        if (isExporting) return;
        if (!startTime) startTime = timestamp;
        const elapsed = (timestamp - startTime) % duration;
        
        const progress = (Math.sin((elapsed / duration) * Math.PI * 2 - Math.PI / 2) + 1) / 2;
        const currentVal = min + (max - min) * progress;

        drawCanvasText(currentVal);

        animationFrame = requestAnimationFrame(step);
      }

      animationFrame = requestAnimationFrame(step);
    }

    [axisMinInput, axisMaxInput, document.getElementById('anim-duration'), fontSizeInput, sampleTextInput].forEach(input => {
      input.addEventListener('input', () => {
        if (!isExporting && currentFontFace) startLivePreview();
      });
    });

    // 4. Native Canvas WebM Stream Recorder
    exportWebmBtn.addEventListener('click', async () => {
      if (isExporting) return;
      isExporting = true;
      cancelAnimationFrame(animationFrame);
      exportWebmBtn.disabled = true;
      exportWebpBtn.disabled = true;

      const tag = axisTagInput.value;
      const min = parseFloat(axisMinInput.value);
      const max = parseFloat(axisMaxInput.value);
      const durationMs = parseFloat(document.getElementById('anim-duration').value) * 1000;
      const formatLabel = aspectRatioSelect.value.replace(':', 'x');

      status.textContent = "Recording WebM video natively...";

      const stream = canvas.captureStream(60);
      
      let mimeType = 'video/webm;codecs=vp9';
      if (!MediaRecorder.isTypeSupported(mimeType)) {
        mimeType = 'video/webm;codecs=vp8';
      }
      if (!MediaRecorder.isTypeSupported(mimeType)) {
        mimeType = 'video/webm';
      }

      const recorder = new MediaRecorder(stream, { mimeType });
      const chunks = [];

      recorder.ondataavailable = (e) => chunks.push(e.data);
      recorder.onstop = () => {
        const blob = new Blob(chunks, { type: 'video/webm' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `font-animation-${tag}-${formatLabel}.webm`;
        a.click();

        status.textContent = "WebM Export complete! File downloaded.";
        exportWebmBtn.disabled = false;
        exportWebpBtn.disabled = false;
        isExporting = false;
        startLivePreview();
      };

      recorder.start();

      let startTime = performance.now();

      function recordStep(now) {
        const elapsed = now - startTime;
        if (elapsed >= durationMs) {
          drawCanvasText(min);
          recorder.stop();
          return;
        }

        const progress = (Math.sin((elapsed / durationMs) * Math.PI * 2 - Math.PI / 2) + 1) / 2;
        const currentVal = min + (max - min) * progress;

        drawCanvasText(currentVal);
        status.textContent = `Recording video... ${Math.round((elapsed / durationMs) * 100)}%`;

        requestAnimationFrame(recordStep);
      }

      requestAnimationFrame(recordStep);
    });

    // 5. Animated WebP Exporter (Full Canvas Resolution)
    exportWebpBtn.addEventListener('click', async () => {
      if (isExporting) return;
      isExporting = true;
      cancelAnimationFrame(animationFrame);
      exportWebmBtn.disabled = true;
      exportWebpBtn.disabled = true;

      const tag = axisTagInput.value;
      const min = parseFloat(axisMinInput.value);
      const max = parseFloat(axisMaxInput.value);
      const durationSec = parseFloat(document.getElementById('anim-duration').value);
      const formatLabel = aspectRatioSelect.value.replace(':', 'x');
      const fps = 30;
      const totalFrames = durationSec * fps;

      status.textContent = "Rendering frames for Animated WebP...";

      const frames = [];
      
      for (let i = 0; i < totalFrames; i++) {
        const progress = (Math.sin((i / totalFrames) * Math.PI * 2 - Math.PI / 2) + 1) / 2;
        const currentVal = min + (max - min) * progress;

        drawCanvasText(currentVal);
        frames.push(canvas.toDataURL('image/webp', 0.9));
        
        if (i % 10 === 0) {
          status.textContent = `Capturing frames... ${Math.round((i / totalFrames) * 100)}%`;
        }
        await new Promise(r => setTimeout(r, 4));
      }

      status.textContent = "Encoding Animated WebP file at full resolution...";

      gifshot.createGIF({
        images: frames,
        interval: 1 / fps,
        numWorkers: 4,
        gifWidth: canvas.width,
        gifHeight: canvas.height,
        outputType: 'webp'
      }, (obj) => {
        if (!obj.error) {
          const bannerImage = obj.image;
          const a = document.createElement('a');
          a.href = bannerImage;
          a.download = `font-animation-${tag}-${formatLabel}.webp`;
          a.click();

          status.textContent = "Animated WebP Export complete!";
        } else {
          status.textContent = "Error generating WebP animation.";
          console.error(obj.error);
        }

        exportWebmBtn.disabled = false;
        exportWebpBtn.disabled = false;
        isExporting = false;
        startLivePreview();
      });
    });
  